import L from 'leaflet';
import * as esri from 'esri-leaflet';
import { Endpoints } from './config.js';

export class MapLayers {
    constructor(mapComponent) {
        this.app = mapComponent;
    }

    setupArcGISLayers() {
        // 1. Campus Plots (Polygons)
        this.app.arcGisLayers.plots = esri.featureLayer({
            url: Endpoints.plots,
            style: () => ({ color: '#888', weight: 1, fillOpacity: 0.2 })
        });

        // 2. Buildings (Polygons)
        this.app.arcGisLayers.buildings = esri.featureLayer({
            url: Endpoints.buildings,
            style: () => ({ color: '#ccc', weight: 2, fillOpacity: 0.6 })
        });

        // 3. Accessible Paths (Polylines)
        this.app.arcGisLayers.paths = esri.featureLayer({
            url: Endpoints.paths,
            where: "fclass = 'footway'",
            style: () => ({ color: '#00BFFF', weight: 3, dashArray: '5, 5' })
        });

        // 4. POIs (Points with distinct filters)
        const poiFilters = {
            elevators: "type = 'Elevator' OR type = 'Ανελκυστήρας'",
            ramps: "type = 'Ramp' OR type = 'Ράμπα'",
            parking: "type = 'Parking' OR type = 'Στάθμευση'",
            wc: "type = 'WC' OR type = 'Τουαλέτα'",
            entrances: "type = 'entrance' OR type = 'entranceamea' OR type = 'Entrance' OR type = 'Είσοδος'"
        };

        for (const [key, whereClause] of Object.entries(poiFilters)) {
            this.app.arcGisLayers[`poi_${key}`] = esri.featureLayer({
                url: Endpoints.pois,
                where: whereClause,
                pointToLayer: (geojson, latlng) => {
                    return L.marker(latlng, {
                        icon: this.getIconForPOI(key)
                    });
                }
            });
        }
    }

    getIconForPOI(poiType) {
        const baseUrl = 'https://pr.uoc.gr/virtualtour/media/map-icons/';
        const icons = {
            elevators: 'elevator1.svg',
            ramps: 'ramp1.svg',
            parking: 'parking1.svg',
            entrances: 'entrance1.svg',
            wc: 'wc1.svg' // assuming a standard name, adjust as needed
        };
        const iconName = icons[poiType] || 'default.svg';
        
        return L.icon({
            iconUrl: baseUrl + iconName,
            iconSize: [24, 24],
            iconAnchor: [12, 12],
            popupAnchor: [0, -12]
        });
    }
}